'use client';
var IDENT = "Skeleton";
var defaultProps = {
    color: "button.secondary",
    accentColor: "background.content",
    spacing: "0",
    align: "center",
    textAlign: "center",
    visible: true,
    animate: true,
    animation: "wave"
};

export { IDENT, defaultProps };
